import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    ref: "menucont",
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("您当前的位置：")]), _c('span', {
    staticClass: "back-user",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/user');
      }
    }
  }, [_vm._v("个人中心")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), !_vm.showInstructions ? _c('span', {
    staticClass: "coupon"
  }, [_vm._v("优惠券")]) : _c('span', [_c('span', {
    staticClass: "back-user",
    on: {
      "click": function click($event) {
        _vm.showInstructions = false;
      }
    }
  }, [_vm._v("优惠券")]), _c('span', {
    staticClass: "slash"
  }, [_vm._v("/")]), _c('span', {
    staticClass: "coupon"
  }, [_vm._v("使用说明")])])]), !_vm.showInstructions ? _c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('span', {
    class: {
      active: _vm.activeIndex === 0
    },
    on: {
      "click": function click($event) {
        return _vm.handleCouponTab(0);
      }
    }
  }, [_vm._v("未使用")]), _c('span', {
    class: {
      active: _vm.activeIndex === 1
    },
    on: {
      "click": function click($event) {
        return _vm.handleCouponTab(1);
      }
    }
  }, [_vm._v("已使用")]), _c('span', {
    class: {
      active: _vm.activeIndex === 2
    },
    on: {
      "click": function click($event) {
        return _vm.handleCouponTab(2);
      }
    }
  }, [_vm._v("已过期")])]), _c('span', {
    staticClass: "desc",
    on: {
      "click": _vm.showDesc
    }
  }, [_vm._v("使用说明")])]) : _vm._e(), !_vm.showInstructions ? [_vm.couponList.length === 0 ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.isLoading,
      expression: "isLoading"
    }],
    staticClass: "no-coupon"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/no_coupon.png"),
      "alt": "",
      "width": "200px",
      "height": "122px"
    }
  }), _c('p', [_vm._v("暂时还没有优惠券哦")])]) : _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.isLoading,
      expression: "isLoading"
    }],
    staticClass: "coupon-list"
  }, _vm._l(_vm.couponList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "for-list"
    }, [_c('div', {
      staticClass: "coupon-info",
      class: {
        'no-used': _vm.activeIndex === 0
      }
    }, [_c('div', {
      staticClass: "price-wrap"
    }, [_c('span', {
      staticClass: "price-ago"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.reduceMoney))])]), _c('div', {
      staticClass: "use-wrap"
    }, [_c('p', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.activityName))]), item.fullReduce > 0 ? _c('p', {
      staticClass: "use"
    }, [_vm._v("满" + _vm._s(item.fullReduce) + "元使用")]) : _c('p', {
      staticClass: "use"
    }, [_vm._v("无门槛券")])]), _vm.activeIndex === 0 ? [item.status !== 1 ? _c('div', {
      staticClass: "to-use",
      on: {
        "click": function click($event) {
          return _vm.$router.push("/couponList?id=".concat(item.id));
        }
      }
    }, [_vm._v("去使用")]) : _vm._e(), item.expireFlag ? _c('div', {
      staticClass: "be-expire"
    }, [_vm._v("即将过期")]) : _vm._e()] : _vm._e()], 2), _vm.activeIndex === 0 && item.status === 1 ? _c('div', {
      staticClass: "coupone-date"
    }, [_vm._v(" 使用时间：" + _vm._s(item.useStartDate) + " "), _c('span', [_vm._v("未开始")])]) : _c('div', {
      staticClass: "coupone-date"
    }, [_vm._v(" 有效期至：" + _vm._s(item.useEndDate) + " "), _vm.activeIndex === 0 && item.status === 1 ? _c('span', [_vm._v("未开始")]) : _vm._e()]), _vm.activeIndex === 1 ? _c('img', {
      attrs: {
        "src": require("@/assets/images/used_coupon.png"),
        "alt": ""
      }
    }) : _vm.activeIndex === 2 ? _c('img', {
      attrs: {
        "src": require("@/assets/images/expired_coupon.png"),
        "alt": ""
      }
    }) : _vm._e()]);
  }), 0), _vm.totalnumber > 0 ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNo,
      "page-sizes": [8, 20, 30],
      "page-size": _vm.pageSize,
      "total": _vm.totalnumber,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.pageNo = $event;
      },
      "size-change": function sizeChange($event) {
        return _vm.handleSizeChange($event);
      },
      "current-change": function currentChange($event) {
        return _vm.handleCurrentChange($event);
      }
    }
  })], 1) : _vm._e()] : _c('div', {
    staticClass: "instruction"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("使用说明")]), _c('div', {
    staticClass: "content"
  }, [_c('el-input', {
    staticClass: "textarea",
    attrs: {
      "type": "textarea",
      "resize": "none",
      "autosize": ""
    },
    model: {
      value: _vm.instruction,
      callback: function callback($$v) {
        _vm.instruction = $$v;
      },
      expression: "instruction"
    }
  })], 1)])], 2)], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };